import { push } from "connected-react-router";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Creators as AllCreators } from "../../actions";
import { IState } from "../reducer";
import { LogoutComponent } from "./Logout.component";
import { ILogoutDispatchProps, ILogoutStateProps } from "./types";

const Creators = (AllCreators as any).App;

const mapStateToProps = (state: IState): ILogoutStateProps => ({
  authenticationState: state.App._.authenticationState,
  logoutRequestState: state.App._.logoutRequestState,
});

const mapDispatchToProps = (dispatch: Dispatch): ILogoutDispatchProps => ({
  onLogOut: () => dispatch(Creators.logout()),
  onLoggedOut: () => dispatch(push("/login")),
});

export const Logout = connect(mapStateToProps, mapDispatchToProps)(LogoutComponent);
